import { render } from "./Subscribers.vue?vue&type=template&id=0c87ff9c&scoped=true"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"

import "./Subscribers.vue?vue&type=style&index=0&id=0c87ff9c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c87ff9c"]])

export default __exports__